module.exports = __webpack_public_path__ + "media/1_3-8.0bfaefaf.mp3";